import { render, staticRenderFns } from "./TapIssue.vue?vue&type=template&id=c96bd362&scoped=true"
import script from "./TapIssue.vue?vue&type=script&lang=js"
export * from "./TapIssue.vue?vue&type=script&lang=js"
import style0 from "./TapIssue.vue?vue&type=style&index=0&id=c96bd362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96bd362",
  null
  
)

export default component.exports